import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { authedRoute } from '../../app/routes-base';

/** `/platform` — platform operator console (roadmap S2, ADR-0032). */
export const platformRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: 'platform',
  component: lazyRouteComponent(() => import('./layout'), 'PlatformLayout'),
});

const tenantsRoute = createRoute({
  getParentRoute: () => platformRoute,
  path: '/',
  component: lazyRouteComponent(() => import('./pages/tenants-page'), 'TenantsPage'),
});

export const tenantDetailRoute = createRoute({
  getParentRoute: () => platformRoute,
  path: 'tenants/$tenantId',
  component: lazyRouteComponent(() => import('./pages/tenant-detail-page'), 'TenantDetailPage'),
});

const plansRoute = createRoute({
  getParentRoute: () => platformRoute,
  path: 'plans',
  component: lazyRouteComponent(() => import('./pages/plans-page'), 'PlansPage'),
});

const settingsRoute = createRoute({
  getParentRoute: () => platformRoute,
  path: 'settings',
  component: lazyRouteComponent(() => import('./pages/settings-page'), 'PlatformSettingsPage'),
});

const adminsRoute = createRoute({
  getParentRoute: () => platformRoute,
  path: 'admins',
  component: lazyRouteComponent(() => import('./pages/admins-page'), 'AdminsPage'),
});

const auditRoute = createRoute({
  getParentRoute: () => platformRoute,
  path: 'audit',
  component: lazyRouteComponent(() => import('./pages/audit-page'), 'AuditPage'),
});

/** Password and authenticator (TOTP is required for platform operators; ADR-0032). */
const accountRoute = createRoute({
  getParentRoute: () => platformRoute,
  path: 'akun',
  component: lazyRouteComponent(() => import('../backoffice/pages/account-page'), 'AccountPage'),
});

export const platformTree = platformRoute.addChildren([
  tenantsRoute,
  tenantDetailRoute,
  plansRoute,
  settingsRoute,
  adminsRoute,
  auditRoute,
  accountRoute,
]);
